<template>
	<el-dialog :visible.sync="dialogVisible" append-to-body top="8vh" :show-close="false" @close="closeDialog">
		<div slot="title" class="flex align-center justify-between">
			<div class="flex align-center">
				<span class="el-icon-user text-gray text-lg"></span>
				<div class="margin-left-xs"><div class="text-bold">查看人员信息</div></div>
			</div>
			<el-link :underline="false" type="info" @click="dialogVisible = false"><i class="el-icon-close text-xxl"></i></el-link>
		</div>
		<div v-loading="loading" element-loading-text="加载中……">
			<div style="height: 70vh; overflow: auto;" class="padding-lr">
				<el-divider content-position="left">工作档案</el-divider>
				<div class="infoshow">
					<div class="title"><span>所属部门</span></div>
					<div class="con">
						<div v-for="dpt in employeeInfo.departmentArr" :key="dpt.id" class="flex align-center padding-tb-xs">
							<el-breadcrumb separator-class="el-icon-arrow-right" class="margin-right-sm">
								<el-breadcrumb-item v-for="(item, idx) in dpt.path" :key="idx">
									<span class="text-grey">{{ item.name }}</span>
								</el-breadcrumb-item>
							</el-breadcrumb>
							<el-tag size="mini" effect="line" v-if="dpt.id == employeeInfo.main_department">主部门</el-tag>
							<el-tag type="warning" size="mini" v-if="dpt.is_leader" class="margin-left-sm">主管</el-tag>
						</div>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>工号</span></div>
					<div class="con">
						<span>{{ employeeInfo.officeid }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>职务</span></div>
					<div class="con">
						<span>{{ employeeInfo.position }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>是否在职</span></div>
					<div class="con">
						<el-tag type="success" size="small" v-if="employeeInfo.stateflag == 1">在职</el-tag>
						<el-tag type="info" size="small" v-else>离职</el-tag>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>入职时间</span></div>
					<div class="con">
						<span class="text-bold">{{ employeeInfo.jointime }}</span>
					</div>
				</div>
				<div class="infoshow" v-if="employeeInfo.stateflag == 0">
					<div class="title"><span>离职时间</span></div>
					<div class="con">
						<span class="text-bold">{{ employeeInfo.leavetime }}</span>
					</div>
				</div>
				<el-divider content-position="left">个人档案</el-divider>
				<div class="infoshow">
					<div class="title"><span>姓名</span></div>
					<div class="con">
						<span>{{ employeeInfo.name }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>性别</span></div>
					<div class="con">
						<span class="cu-tag bg-blue light radius" v-if="employeeInfo.gender == 1">男</span>
						<span class="cu-tag bg-pink light radius" v-else-if="employeeInfo.gender == 2">女</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>民族</span></div>
					<div class="con">
						<span>{{ employeeInfo.people }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>籍贯</span></div>
					<div class="con">
						<span>{{ employeeInfo.birthplace }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>婚姻</span></div>
					<div class="con">
						<span class="cu-tag line-cyan round" v-if="employeeInfo.marriage == 1">未婚</span>
						<span class="cu-tag line-cyan round" v-else-if="employeeInfo.marriage == 2">已婚</span>
						<span class="cu-tag line-grey round" v-else>未知</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>身份证号</span></div>
					<div class="con">
						<span>{{ employeeInfo.idcard }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>生日</span></div>
					<div class="con">
						<span>{{ employeeInfo.birthday }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>手机号码</span></div>
					<div class="con">
						<span>{{ employeeInfo.mobile }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>微信号码</span></div>
					<div class="con">
						<span>{{ employeeInfo.weixin }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>QQ号码</span></div>
					<div class="con">
						<span>{{ employeeInfo.qq }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>邮箱</span></div>
					<div class="con">
						<span>{{ employeeInfo.email }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>住址</span></div>
					<div class="con">
						<span>{{ employeeInfo.address }}</span>
					</div>
				</div>
				<div class="infoshow">
					<div class="title"><span>联系人</span></div>
					<div class="con">
						<span class="text-brown text-bold">{{ employeeInfo.linkman.name }}</span>
						<span class="text-bold margin-left-xs">({{ employeeInfo.linkman.mobile }})</span>
						<span class="cu-tag sm line-orange radius margin-left-xs">{{ employeeInfo.linkman.gx }}</span>
					</div>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'employee-view',
	props: {
		visible: {
			type: Boolean,
			default: () => {
				return false;
			}
		},
		userId: {
			type: String,
			default: () => {
				return '';
			}
		},
		config: {
			type: Object,
			default: () => {
				return { avatarSize: 128 };
			}
		}
	},
	data() {
		return {
			dialogVisible: false,
			id: '',
			cfg: {},
			employeeInfo: {
				gender: '',
				people: '汉族',
				marriage: 0,
				department: [],
				linkman: {}
			},
			loading: false,
			isLoad: false
		};
	},
	created: function() {},
	mounted() {
		this.dialogVisible = this.visible;
		this.id = this.userId;
		this.cfg = this.config;
	},
	methods: {
		init() {
			if (this.dialogVisible) {
				if (!this.isLoad) {
					this.getEmployeeInfo();
				}
			}
		},
		closeDialog() {
			this.dialogVisible = false;
			this.$emit('close', false);
		},
		getEmployeeInfo() {
			this.loading = true;
			this.$http.post('/server/index.php?m=hr/department&a=getEmployeeInfo', { id: this.id }).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.employeeInfo = res.data;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		}
	},
	watch: {
		userId: function(val) {
			this.id = val;
			this.isLoad = false;
			this.init();
		},
		visible: function(val) {
			this.dialogVisible = val;
			this.init();
		}
	}
};
</script>

<style>
.infoshow-list {
	display: flex;
	justify-content: space-between;
}
</style>
